import type { WexlerStandardField } from './relativity-field-mapping.entity.js';

/**
 * Single source of truth: Field registry mapping field names to their types
 * Adding a new field? Just add one line here!
 */
export const FIELD_REGISTRY = {
  controlNumber: 'text',
  fileType: 'text',
  fileSize: 'number',
  emailFrom: 'text',
  emailTo: 'text[]',
  emailSubject: 'text',
  emailSentDate: 'date',
  emailReceivedDate: 'date',
  documentDate: 'date',
  author: 'text',
  title: 'text',
  containerName: 'text',
  containerId: 'text',
  filePath: 'text',
  pageCount: 'number',
  issues: 'text[]',
} as const;

/**
 * Standard Wexler fields that can be mapped from Relativity
 * Automatically derived from FIELD_REGISTRY
 */
export const WEXLER_STANDARD_FIELDS = Object.keys(FIELD_REGISTRY) as WexlerStandardField[];

/**
 * Helper to get fields by type from registry
 */
function getFieldsByType(targetType: string): WexlerStandardField[] {
  return Object.entries(FIELD_REGISTRY)
    .filter(([, type]) => type === targetType)
    .map(([field]) => field as WexlerStandardField);
}

/**
 * Wexler text fields - store string values
 * Automatically derived from FIELD_REGISTRY
 */
export const WEXLER_TEXT_FIELDS = getFieldsByType('text');

/**
 * Wexler text array fields - store string arrays
 * Values will be split from source using configured separator (default: semicolon)
 * Automatically derived from FIELD_REGISTRY
 */
export const WEXLER_TEXT_ARRAY_FIELDS = getFieldsByType('text[]');

/**
 * Wexler number fields - store numeric values
 * Automatically derived from FIELD_REGISTRY
 */
export const WEXLER_NUMBER_FIELDS = getFieldsByType('number');

/**
 * Wexler date fields - store timestamp values
 * Automatically derived from FIELD_REGISTRY
 */
export const WEXLER_DATE_FIELDS = getFieldsByType('date');
